export default __webpack_public_path__ + "051f3231b3a66385d56d78842f018afd.svg";